var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup45(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.568,
    height: 154.195,
    viewBox: "0 0 147.568 154.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(329.719 -1822.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M831.955,896.782a31.689,31.689,0,0,1-11.312,24.309h-6.628V897.31a13.206,13.206,0,0,0-26.412,0v28.645a31.768,31.768,0,1,1,44.352-29.173",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M800.191,823a73.783,73.783,0,0,0-12.438,146.511,15.829,15.829,0,0,1-.15-2.193v-.368l-3.668-11.771A60.67,60.67,0,1,1,845.928,936.5c.04.429.06.857.06,1.3v.4l-2.083,17.99A73.759,73.759,0,0,0,800.191,823",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M839.151,937.795l-.688,5.95-2,17.272-.727,6.3a9.874,9.874,0,0,1-9.877,9.877H804.307a9.851,9.851,0,0,1-9.378-6.817,9.736,9.736,0,0,1-.489-3.06v-1.4l-2.84-9.129-4.366-14.014a7.736,7.736,0,0,1,7.206-10.026V897.31a6.369,6.369,0,1,1,12.738,0v30.618h22.1a9.872,9.872,0,0,1,9.877,9.867",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup45);
export default __webpack_public_path__ + "static/media/Group 45.3f687b79a51cb88e70d7e33466530155.svg";
export { ForwardRef as ReactComponent };